import React from "react";
import "./styles.scss";
import { ReactComponent as Avatar } from "../../../../public/shared/avatar-default.svg";

export default ({ className, user }) => {
  let profile_picture = null;
  if (!!user) {
    profile_picture = user.profile_picture;
  }
  return profile_picture && profile_picture.url ? (
    <img
      className={`profile-picture rounded-circle ${className ? className : ""}`}
      width={40}
      height={40}
      src={profile_picture.url}
      alt="profile_picture"
    />
  ) : (
    <Avatar
      className={`profile-picture rounded-circle ${className ? className : ""}`}
      width={40}
      height={40}
      alt="profile_picture"
    />
  );
};
